import { render, staticRenderFns } from "./ProfileContainer.vue?vue&type=template&id=0590fc3e"
import script from "./ProfileContainer.vue?vue&type=script&lang=ts"
export * from "./ProfileContainer.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports